import type { ReactNode } from 'react';

import { cn } from '../../utils/cn';
import { formatNumber } from '../../utils/format-number';

export function MetricCard({
  className,
  title,
  value,
  suffix,
}: {
  className?: string;
  title: ReactNode;
  value: number;
  suffix?: ReactNode;
}) {
  return (
    <div
      className={cn(
        'space-y-1 rounded-lg border border-zinc-200 bg-white p-6 shadow-sm',
        className,
      )}
    >
      <div className="text-sm text-zinc-500">{title}</div>
      <div className="text-2xl font-bold text-zinc-950">
        {formatNumber(value)}
        {suffix}
      </div>
    </div>
  );
}
